"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var styles = {
  "major-version-properties": "MajorVersionProperties__major-version-properties__eAtZM",
  "majorVersionProperties": "MajorVersionProperties__major-version-properties__eAtZM",
  "version-group-label": "MajorVersionProperties__version-group-label__9HdGZ",
  "versionGroupLabel": "MajorVersionProperties__version-group-label__9HdGZ",
  "minor-version-label": "MajorVersionProperties__minor-version-label__qJI1s",
  "minorVersionLabel": "MajorVersionProperties__minor-version-label__qJI1s",
  "separator": "MajorVersionProperties__separator__2Q2Mg"
}; 
require('./MajorVersionProperties.css');
var getVisibilityLabel = function getVisibilityLabel(isPublic) {
  return isPublic ? 'Public' : 'Private';
};
var MajorVersionProperties = function MajorVersionProperties(_ref) {
  var asset = _ref.asset;
  var portalContext = (0, _react.useContext)(_exchangeReactHooks.AssetPortalContext);
  var isVersionGroupNavigation = portalContext.versionsNavigation === 'version-group';
  if (!isVersionGroupNavigation) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.majorVersionProperties,
    "data-test-id": "major-version-properties"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.versionGroupLabel
  }, asset.versionGroup), /*#__PURE__*/_react.default.createElement("span", null, getVisibilityLabel(asset.isPublic)), /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "major-version-separator",
    className: styles.separator
  }));
};
var _default = exports.default = MajorVersionProperties;
//# sourceMappingURL=MajorVersionProperties.js.map